import axios from 'axios'
import qs from 'qs'
import store from '../store/index'
// 引入封装的AES加密解密方法
import { aesEncryptECB, aesDecryptECB } from '@/tools/AES'

// 请求拦截器：参数加密
axios.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  
  // 处理GET请求的查询参数加密
  if (config.method?.toUpperCase() === 'GET' && config.params) {
    // 将params转换为JSON字符串后整体加密
    const paramsStr = JSON.stringify(config.params)
    const encryptedParams = aesEncryptECB(paramsStr)
    // 将加密后的字符串作为单个参数传递，后端需对应解析
    config.params = {
      sign: encryptedParams
    }
  }

  // 处理请求体数据加密（适用于POST等方法）
  config.transformRequest = [data => {
    if (data && typeof data === 'object') {
      // 将data转换为JSON字符串后整体加密
      const dataStr = JSON.stringify(data)
      const encryptedData = aesEncryptECB(dataStr)
      // 序列化为单个参数
      return qs.stringify({
        sign: encryptedData
      })
    }
    return qs.stringify(data)
  }]

  config.headers['token'] = store.state.token
  return config
}, error => {
  console.log(error.message)
  return Promise.reject(error)
})

// 响应拦截器：数据解密
axios.interceptors.response.use(response => {
  // 对响应数据进行解密处理
  if (response.data) {
    try {
      // 根据后端返回的数据结构进行解密
      response.data = JSON.parse(aesDecryptECB(response.data))
      console.log(response.data);
      
    } catch (error) {
      console.error('响应数据解密失败:', error)
    }
  }
  return response
}, err => {
  try {
    console.log(err)
    // 对错误响应中的数据也尝试解密（如果需要）
    if (err.response && err.response.data) {
      try {
        err.response.data = aesDecryptECB(err.response.data)
      } catch (e) {
        console.error('错误数据解密失败:', e)
      }
    }
  } catch (error) {
    console.log(error)
  }
  return Promise.reject(err)
})

export default axios